export const currencyFormat = (amount, currency) => {
  if (currency) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
    }).format(amount);
  }
};

export const customFormat = (amount) => {
  // Ensure the amount is a number and always has two decimal places
  const [whole, decimal] = amount.toFixed(2).split('.');

  // Add thousand separators using comma
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine whole and decimal parts with period as the decimal separator
  return `${formattedWhole}.${decimal}`;
};


// In utils/formatUtils.js
export const currencyFormatLKR = (
  amount,
  currency = "LKR",
  showCurrencyLabel = true
) => {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "LKR",
    currencyDisplay: "symbol",
  }).format(amount);
  return showCurrencyLabel
    ? `${formattedAmount}`
    : formattedAmount.replace(/LKR\s?/, "");
};

export default currencyFormat;

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return ""; // Return an empty string if the date is invalid
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
